import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { TimepickerModule } from 'ngx-bootstrap/timepicker';

import { ManualEntryComponent } from './manual-entry/manual-entry.component';
import { AppRoutingModule } from '../app-routing.module';



@NgModule({
  declarations: [
    ManualEntryComponent
  ],
  imports: [
    CommonModule,
    AppRoutingModule,
    FormsModule,
    TimepickerModule.forRoot(),
    BsDatepickerModule.forRoot(),
    ReactiveFormsModule,
  ],
  exports: [
    ManualEntryComponent
  ]
})
export class StrikeWalksModule { }
